import { Paragraph } from 'react-native-paper';
import styled from 'styled-components/native';

export default styled<typeof Paragraph>(Paragraph)`
  color: ${(props) => props.theme.colors.text};
`;
